import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { Tabs, Tab } from '@material-ui/core';
import isObject from 'lodash/isObject';
import './ScoringLearnosityItem.scss';

// render learnosity item split with tabs on scoring ui
const ScoringLearnosityItem = ({
  reference,
  isCurrent,
  learnosityQuestion,
  learnosityItem,
  questionId,
  questionIndex,
  isLoading,
  responseTabLabel,
  isPrintTest,
  isMobile,
  reshapeTwoColumnQuestions,
}) => {
  // one item with many questions, can be only FRQ
  const isMultiPart = learnosityItem && learnosityItem.questions.length > 1;
  const [itemTabIndex, setItemTabIndex] = useState(0);

  let response = learnosityQuestion && learnosityQuestion.getResponse();

  if (isObject(response) && isObject(response.value)) {
    response = response.value;
  }

  const showNoResponseMessage = !isLoading && itemTabIndex === 1 && !response;

  useEffect(() => {
    if (learnosityQuestion) {
      setItemTabIndex(isMultiPart || isPrintTest ? 0 : 1);
    }
  }, [isCurrent, isMultiPart, isLoading]);

  function handleChange(event, newValue) {
    setItemTabIndex(newValue);
  }

  if (!reference) {
    return null;
  }

  const questionTitle = isMobile ? 'Question' : `Question ${questionIndex + 1}`;
  const multiPartLabel = isMobile
    ? responseTabLabel
    : `${questionTitle} / ${responseTabLabel}`;

  const itemColumns = document.querySelectorAll(
    `#scoring-block-${questionId} .learnosity-item .col-xs-6`,
  );
  if (itemColumns && itemColumns.length) {
    itemColumns.forEach((column) => {
      column.classList.remove('col-xs-6');
      column.classList.add('col-xs-12');
      column.classList.add('col-sm-6');
    });
  }

  const reshapeTwoColumnLayout = () => {
    const studentResponseColumn = document.querySelector(
      `#scoring-block-${questionId} .learnosity-item .col-xs-6:nth-child(2)`,
    );
    if (studentResponseColumn) {
      const tabPanel = document.querySelector(
        `#scoring-block-${questionId} .learnosity-control-item > div`,
      );
      const responseWrapper = studentResponseColumn.querySelector(
        '.lrn_response_wrapper',
      );
      if (responseWrapper) {
        tabPanel.appendChild(responseWrapper);
        responseWrapper.classList.add('moved');
      }
    }
  };

  useEffect(() => {
    document
      .querySelectorAll('.CodeMirror')
      .forEach((e) => e?.CodeMirror?.refresh());
  }, [document.querySelectorAll('.CodeMirror')]);

  useEffect(() => {
    reshapeTwoColumnQuestions && reshapeTwoColumnLayout();
  });

  return (
    <Fragment>
      {isLoading ? (
        <div className="mt-25">
          <LoadingSpinner />
        </div>
      ) : (
        <Tabs
          variant="fullWidth"
          value={itemTabIndex}
          onChange={handleChange}
          textColor="primary"
          className="ScoringLearnosityItem"
        >
          <Tab label={isMultiPart ? multiPartLabel : questionTitle} />
          {!isMultiPart && <Tab label={responseTabLabel} />}
        </Tabs>
      )}

      <div className="scroll">
        <div
          role="tabpanel"
          tabIndex="0"
          hidden={isLoading}
          className={cn({
            'learnosity-control-item': itemTabIndex === 0 || itemTabIndex === 1,
            '--visible-all': isMultiPart,
            '--hide-response': itemTabIndex === 0 || !response,
            '--hide-question': itemTabIndex === 1,
          })}
        >
          {showNoResponseMessage && <p>No response entered</p>}

          <div>
            <div
              className="learnosity-item"
              data-reference={reference}
              data-test-reference-visible={isCurrent}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

ScoringLearnosityItem.propTypes = {
  responseTabLabel: PropTypes.string,
};

ScoringLearnosityItem.defaultProps = {
  responseTabLabel: 'Student Response',
};

export default ScoringLearnosityItem;
